import React, { useState, useRef, useEffect } from "react";
import styles from "./TransactionsPaymentMain.module.css";
import { paymentPopupApi } from "../../../config/paymentPopupApi";
import { getAVisaApplicationApi } from "../../../config/getAVisaApplicationApi";
import {countryApiId} from '../../../config/countryApiId'

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";
import moment from "moment";
import { useHistory, useParams } from "react-router-dom";
import Radio from "@material-ui/core/Radio";

import bank1 from "../../../assets/images/bank1.png";
import bank2 from "../../../assets/images/bank2.png";
import bank3 from "../../../assets/images/bank3.png";
import bank4 from "../../../assets/images/bank4.PNG";

function TransactionsPaymentMain(props) {
  const [loading, setLoading] = useState(false);
  const [mainLoading, setMainLoading] = useState(true)

  const [country, setCountry] = useState("");
  const [persons, setPersons] = useState("");
  const [total, setTotal] = useState(0);
  const [visaType, setVisaType] = useState("");
  const [service, setSerivce] = useState("");
  const [travelDate, setTravelDate] = useState("");
  const [bank, setBank] = useState("");
  const [serviceFee, setServiceFee] = useState("")
  const [embassyFee, setEmbassyFee] = useState("")
  //   const date2 = moment(new Date(props.details.return_date));
  //   const return_date = date2.format("DD/MM/YYYY");

  //   const return_date1 = date2.toISOString();

  const [token, setToken] = useState("");

  const history = useHistory();
  let { id } = useParams();
  const payBtn = useRef("");

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      setToken(item.value.token);

      const application = async (token1) => {
        const application1 = await getAVisaApplicationApi(token1,id);
        console.log(application1)

        if (application1.error) {
            console.log(application1.error);
            toast.error(
                <span style={{ display: "flex", alignItems: "center" }}>
                  <BiError size="30" style={{marginRight: "10px"}} />
                  Invalid Applicatiton
                </span>,
                {
                  position: "bottom-left",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                }
              );
            setTimeout(() => {
              history.goBack()
            }, 1000);
        } else if (application1.data) { 
          setEmbassyFee(application1.data.data.cost.embassy_fee)
          setServiceFee(application1.data.data.cost.total_cost - application1.data.data.cost.embassy_fee)

          setTotal(application1.data.data.cost.total_cost)
          setPersons(application1.data.data.travellers_count)
          setSerivce(application1.data.data.plan_type.toLowerCase())
          setVisaType(application1.data.data.visa_package.name)
          const date1 = moment(new Date(application1.data.data.departure_date));
          const travel_date = date1.format("DD/MM/YYYY");
          setTravelDate(travel_date)


          const country = await countryApiId(application1.data.data.visa_package.country);
          if(country.data){
            setMainLoading(false)    
            setCountry(country.data.data.display_name);
          }
          else if(country.error){
            console.log(country.error);
            toast.error(
                <span style={{ display: "flex", alignItems: "center" }}>
                  <BiError size="30" style={{marginRight: "10px"}} />
                  Invalid Applicatiton
                </span>,
                {
                  position: "bottom-left",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                }
              );
            setTimeout(() => {
              history.goBack()
            }, 1000);
          }

          
         
        }
      };

      application(item.value.token);
    }
    getWithExpiry("userData");
  }, []);

  const pay = () => {
    if (bank === "") {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Select Payment Method!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else {
      payBtn.current.setAttribute("disabled", "disabled");
      //   const visa = async () => {

      const payment = async () => {
        setLoading(true)
        const payment = await paymentPopupApi(
          id,
          token,
          bank.toLowerCase(),
           `http://visapro1.netlify.app/dashboard/transactions/payment/successful?provider=${bank}`
          //  `http://localhost:3000/dashboard/transactions/payment/successful?provider=${bank}`

        );

        if (payment.error) {
          toast.error(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BiError size="30" style={{ marginRight: "10px" }} />
              {payment.error.response.data.message}
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
          payBtn.current.removeAttribute("disabled");
        setLoading(false)

        } else if (payment.data) {
          window.location.replace(payment.data.data.link);
          payBtn.current.removeAttribute("disabled");
        setLoading(false)

        }
      };
      payment();
      // }
    }
    //   visa();
  };
  return (
    <div>
        {mainLoading ?(
             <>
             <h2 className={styles.head}>Make Payment Now</h2>
             <div className={styles.loader}>
               <div className="spinner-border" role="status"></div>
             </div>
           </>
        )
        :
        (
            <>
            <h2 className={styles.head}>Make Payment Now</h2>
            <div className={styles.topBox}>
            <div className={styles.totalCont}>
              <h1 className={styles.totalTittle}>Booking details</h1>
              <div className={styles.totalBox}>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Destination</h1>
                  <h1 className={styles.eachValue}>{country}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Visa type</h1>
                  <h1 className={styles.eachValue}>{visaType}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Travel date</h1>
                  <h1 className={styles.eachValue}>{travelDate}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Priority</h1>
                  <h1 className={styles.eachValue}>{service}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Service charges</h1>
                  <h1 className={styles.eachValue}>₦ {serviceFee.toLocaleString()}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Embassy visa fees</h1>
                  <h1 className={styles.eachValue}>₦ {embassyFee.toLocaleString()}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>No of persons</h1>
                  <h1 className={styles.eachValue}>{persons}</h1>
                </div>
              </div>
              <hr />
              <div className={styles.totalEnd}>
                <h1 className={styles.total}>Total</h1>
                <h1 className={styles.total}>₦ {total.toLocaleString()}</h1>
              </div>
            </div>
    
            <div className={styles.paymentBox}>
              <h1 className={styles.loginHeading}>Select payment method</h1>
              <div className={styles.selectMethodBox}>
                <button
                  className={styles.selectBtn}
                  onClick={() => {
                    setBank("interSwitch");
                  }}
                >
                  <img src={bank1} alt="Bank 1" className={styles.btnImage} />
                  <Radio
                    onChange={() => {
                      setBank("interSwitch");
                    }}
                    checked={bank === "interSwitch"}
                    value="normal"
                    color="default"
                    name="bank"
                  />
                </button>
                <button
                  className={styles.selectBtn}
                  onClick={() => {
                    setBank("paystack");
                  }}
                >
                  <img src={bank2} alt="Bank 2" className={styles.btnImage} />
                  <Radio
                    onChange={() => {
                      setBank("paystack");
                    }}
                    checked={bank === "paystack"}
                    value="normal"
                    color="default"
                    name="bank"
                  />
                </button>
                <button
                  className={styles.selectBtn}
                  onClick={() => {
                    setBank("flutterwave");
                  }}
                >
                  <img src={bank3} alt="Bank 3" className={styles.btnImage} />
                  <Radio
                    onChange={() => {
                      setBank("flutterwave");
                    }}
                    checked={bank === "flutterwave"}
                    value="normal"
                    color="default"
                    name="bank"
                  />
                </button>
                <button
                  className={styles.selectBtn}
                  onClick={() => {
                    setBank("manual");
                  }}
                >
                  <img src={bank4} alt="Bank 4" className={styles.btnImage} />
                  <Radio
                    onChange={() => {
                      setBank("manual");
                    }}
                    checked={bank === "manual"}
                    value="normal"
                    color="default"
                    name="bank"
                  />
                </button>
              </div>
              <div className={styles.signUpbtnCont}>
                <button
                  className={styles.paybtn}
                  onClick={() => pay()}
                  ref={payBtn}
                >
                  {loading ? (
                    <div class="spinner-border" role="status"></div>
                  ) : (
                    `Pay NGN ${total.toLocaleString()}`
                  )}
                </button>
              </div>
            </div>
          </div>
          </>
        )
    }


      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}

export default TransactionsPaymentMain;
